import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../shared/shared.module';
import { BoatOwnerComponent } from './boat-owner.component';
import { BoatOwnerRoutingModule } from './boat-owner-routing.module';
import { BoatOwnerResolve } from './boat-owner.resolve';
import { AppMaterialModule } from '../../../shared/appMaterial/app-material.module';
import { ListGridModule } from '../../../shared/listGrid/listGrid.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    AppMaterialModule,
    SharedModule,
    BoatOwnerRoutingModule,
    MatDialogModule,
    ListGridModule,
  ],
  declarations: [BoatOwnerComponent],
  entryComponents: [],
  exports: [BoatOwnerComponent],
  providers: [BoatOwnerResolve],
})
export class BoatOwnerModule {}
